module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n6n8r7n-266c80f0d3bfd0e7ddd7f4595b95c579.svg";